type Context = 'integration';

type IntegrationType = 'microsoftDynamics';

type Section = 'owner-mappings' | 'owners' | 'fbl-fields' | 'fields' | 'field-mappings' | 'settings';

type Value = `${Context}-${IntegrationType}-${Section}`;

export const Keys: Record<Section, Value> = {
  'owner-mappings': 'integration-microsoftDynamics-owner-mappings',
  owners: 'integration-microsoftDynamics-owners',
  'fbl-fields': 'integration-microsoftDynamics-fbl-fields',
  fields: 'integration-microsoftDynamics-fields',
  'field-mappings': 'integration-microsoftDynamics-field-mappings',
  settings: 'integration-microsoftDynamics-settings',
};
